import { Skeleton } from '@app/components/various/Skeleton';

export const CheckoutTermsAndConditionsSkeleton = () => {
  return (
    <div className="box">
      <div className="mb-5 max-w-72">
        <Skeleton type="text" size="large" />
      </div>
      <div className="flex items-center gap-4">
        <Skeleton type="rectangle" className="size-5" />
        <div className="w-full">
          <Skeleton type="text" width={80} />
        </div>
      </div>
    </div>
  );
};
